import axios from "axios";
import { BASE_PATH } from "../../../services/base";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface RemovePatientFromFlagParams {
  patientFlagId: string;
  patientUuid: string;
  xTENANTID?: string;
}

export const useRemovePatientFromFlag = () =>
  useMutationWithLoading(async (params: RemovePatientFromFlagParams) => {
    const config = getConfigObject();
    return axios.put(
      `${BASE_PATH}/api/master/patient-flags/${params.patientFlagId}/remove-patient/${params.patientUuid}`,
      undefined,
      {
        headers: {
          Authorization: `Bearer ${config.accessToken}`,
          ...(params.xTENANTID && { "X-TENANT-ID": params.xTENANTID }),
        },
      }
    );
  });
